import ProjectCreateContainer from '../../../../Componant/Application/Project/ProjectCreate/ProjectCreate'

const ProjectCreate = () => {
  return (
    <div className='page-body'>
      <ProjectCreateContainer />
    </div>
  )
}

export default ProjectCreate